import { CountdownRenderProps } from 'react-countdown';
import { ICounterUnit } from './countdownTimer.interface';

class CountdownTimerService {
  getTimeSections = (
    { days, hours, minutes, seconds }: Pick<CountdownRenderProps, 'days' | 'hours' | 'minutes' | 'seconds'>,
    units: ICounterUnit[],
  ) => {
    const daysCounter = String(days).padStart(2, '0');
    const hoursCounter = units.includes('days')
      ? String(hours).padStart(2, '0')
      : String(hours + days * 24).padStart(2, '0');
    const minutesCounter = String(minutes).padStart(2, '0');
    const secondsCounter = String(seconds).padStart(2, '0');

    const counters: Record<ICounterUnit, string> = {
      days: daysCounter,
      hours: hoursCounter,
      minutes: minutesCounter,
      seconds: secondsCounter,
    };

    return units.map((unit) => counters[unit]);
  };

  simpleRenderer = (props: CountdownRenderProps, units: ICounterUnit[]) => {
    return this.getTimeSections(props, units).join(':');
  };
}

export const countdownTimerService = new CountdownTimerService();
